import { env } from '@/lib/runtime-env'

import { LOCAL_ORIGIN } from '@/constants/domain'
import { getCreateDomain, getWorldsDomain } from '@/lib/configs'
import type { AppConfig } from '@/types/configs'
import type { OriginConfig } from '@viveportengineering/share-component'

type AppConfigLinks = Partial<AppConfig['links']>

export function buildShareComponentOriginConfig(links?: AppConfigLinks): OriginConfig {
  const isDevelopment = process.env.NODE_ENV === 'development'
  const { viverse_landing, viverse_market, viverse_avatar } = links || {}

  return {
    viverse: isDevelopment ? LOCAL_ORIGIN : (viverse_landing?.replace(/\/$/, '') ?? LOCAL_ORIGIN),
    world: isDevelopment ? LOCAL_ORIGIN : `https://${getWorldsDomain()}`,
    market: viverse_market?.replace(/\/$/, '') || 'https://market.viverse.com',
    avatar: viverse_avatar?.replace(/\/$/, '') || 'https://avatar.viverse.com',
    create: isDevelopment ? LOCAL_ORIGIN : `https://${getCreateDomain()}`,
    document: 'https://docs.viverse.com',
    viveport: 'https://www.viveport.com',
    beatday: 'https://beatday.com',
    lab: 'https://www.viverse.com',
    studio: env('NEXT_PUBLIC_CREATOR_STUDIO_URL') || 'https://studio.viverse.com',
    persona: 'https://persona.viverse.com',
    blog: 'https://news.viverse.com',
  }
}
